import * as React from "react";

export function Select({ children }) {
  return <div className="relative w-full">{children}</div>;
}

export const SelectTrigger = ({ children }) => (
  <div className="border rounded-md px-3 py-2 w-full cursor-pointer">
    {children}
  </div>
);

export const SelectValue = ({ placeholder }) => (
  <span className="text-gray-500">{placeholder}</span>
);

export const SelectContent = ({ children }) => (
  <div className="mt-2 border rounded-md shadow bg-white absolute w-full z-10">
    {children}
  </div>
);

export const SelectItem = ({ value, children }) => (
  <div
    className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
    data-value={value}
  >
    {children}
  </div>
);
